module.exports = __webpack_public_path__ + "static/media/Avenir-HeavyOblique.e037514f.woff2";